import { render, staticRenderFns } from "./OptionTree.vue?vue&type=template&id=b4d2a988&scoped=true"
import script from "./OptionTree.vue?vue&type=script&lang=js"
export * from "./OptionTree.vue?vue&type=script&lang=js"
import style0 from "./OptionTree.vue?vue&type=style&index=0&id=b4d2a988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d2a988",
  null
  
)

export default component.exports